import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions, getParam} from '../question-helper';

@Component({
    selector: 'app-question-toggle-button',
    templateUrl: './question-toggle-button.component.html',
    styleUrls: ['./question-toggle-button.component.scss'],
    standalone: false
})
export class QuestionToggleButtonComponent implements OnInit, OnChanges {

  @Input() items: any[] = [];
  @Input() labelText: string;
  @Input() question: Question;
  @Input() showLabel = true;
  @Input() readonly = false;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `radio-toggle-${newGuid()}`;
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor() { }

  ngOnInit(): void {
    if (this.question && this.question.options) {
      this.items = parseOptions(this.question.options);
      if (this.question?.answer) {
        for (const q of this.items) {
          if (q === this.question?.answer) {
            //this.checkRadio(q.answer);
          }
        }
      }
    } else if (!this.items?.length) {
      this.items = [
        {answer: 'Yes', image_url: '#success-small'},
        {answer: 'No', image_url: '#close-circle-small'}
      ];
      //this.checkRadio(this.items[0].answer);
    }
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.items = parseOptions(changes?.question?.currentValue?.options);
    } else if (changes?.items?.currentValue) {
      this.items = changes?.items?.currentValue;
    }
  }

  checkRadio(answer: any): void {
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
}
